import React, { useEffect } from "react";
import { Outlet } from "react-router";
// @ts-ignore
// import bback from "assets/images/bback.png";
// @ts-ignore
import b1 from "assets/images/b1.png";
// @ts-ignore
import b2 from "assets/images/b2.png";
import ErrorBoundary from "../../../components/ErrorBoundaries";

export default function AccountContainer() {

  return (
    <div className="relative">
      <div className="sticky top-0 -z-50">
        <div
          className="absolute top-0 w-full dark:hidden"
          style={{ zIndex: "-10" }}
        >
          <img src={b1} alt="b1" className="w-full" />
        </div>
        <div
          className="absolute top-0 w-full hidden dark:block"
          style={{ zIndex: "-10" }}
        >
          <img src={b2} alt="b1" className="w-full" />
        </div>
        {/* <div className="relative" style={{ zIndex: "-10" }}>
          <img
            src={bback}
            alt="bback"
            className="fixed -bottom-10 w-[480px] px-0 bg-white"
          />
        </div> */}
      </div>
      <div className="">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
}
